import { FunctionComponent } from "react"
import SignUpForm from "../features/auth/components/signup-form"

const SignUp: FunctionComponent = () => {
  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-col pt-[110px] px-8 pb-12 box-border items-center justify-start">
      <SignUpForm />
    </div>
  )
}

export default SignUp
